import { isWeaveUser } from '@frontend/auth-helpers';
import { useAppScopeStore } from '@frontend/scope';
import { Chip, ChipProps } from '@frontend/design-system';

/**
 * This LocationChip will only show up if the user has access to more than one location.
 */
export const LocationChip = (props: ChipProps) => {
  const { accessibleLocationIds } = useAppScopeStore();
  const shouldShow = isWeaveUser() || accessibleLocationIds.length !== 1;

  if (shouldShow) {
    return <Chip.Location {...props} />;
  }

  return null;
};
